const __request = require(`./__request/__request_contentType_json`);

// 国内机票儿童
export default (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: 'buyer/dom/manage/adultTicket',
        data: data
    }

    return __request(pParameter)
}


